// extracted by mini-css-extract-plugin
export default {"customNode":"GroupNode_customNode__fYQ1C","nodeTitle":"GroupNode_nodeTitle__ThbTe","title":"GroupNode_title__ATKPs","nodeBox":"GroupNode_nodeBox__O4Rjj"};